
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { SortOption } from "@/types/prop-bots";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";

interface PropBotToolbarProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  sortBy: SortOption;
  onSortChange: (value: SortOption) => void;
}

export const PropBotToolbar = ({
  searchTerm,
  onSearchChange,
  sortBy,
  onSortChange
}: PropBotToolbarProps) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  return (
    <div className={`flex flex-col ${isMobile ? "gap-3 mb-4" : "sm:flex-row gap-4 mb-6"}`}>
      <div className="relative flex-1">
        <Search className={`absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground ${isMobile ? "w-3.5 h-3.5" : "w-4 h-4"}`} />
        <Input
          placeholder={t('search_placeholder')}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className={`${isMobile ? "pl-8 h-9 text-sm" : "pl-9"}`}
          data-tour="prop-bot-search"
        />
      </div>
      <div className="flex gap-2">
        <Button
          variant={sortBy === 'pass_rate' ? 'default' : 'outline'}
          onClick={() => onSortChange('pass_rate')}
          size={isMobile ? "sm" : "default"}
          className={isMobile ? "text-xs" : ""}
        >
          {t('pass_rate')}
        </Button>
        <Button
          variant={sortBy === 'estimated_pass_time' ? 'default' : 'outline'}
          onClick={() => onSortChange('estimated_pass_time')}
          size={isMobile ? "sm" : "default"}
          className={isMobile ? "text-xs" : ""}
        >
          {t('est_pass_time')}
        </Button>
      </div>
    </div>
  );
};
